module.exports = __webpack_public_path__ + "img/urmet.44c499bc.png";